/**
 * Vrátí řetězec s úplnou adresou.
 * @param adresa
 * @returns {string}
 */
export function getUplnaAdresa(adresa) {
    const result = [];
    if (adresa.ulice) result.push(adresa.ulice);
    if (adresa.obec) result.push(adresa.obec);
    if (adresa.psc) result.push(adresa.psc);
    if (adresa.stat) result.push(adresa.stat);
    return result.join(", ");
}
